import { createTheme, initializeIcons, registerIcons, setIconOptions } from '@fluentui/react'

import getConfig from 'next/config'

setIconOptions({
  disableWarnings: true
})

export const sellessITheme = createTheme({
  defaultFontStyle: {
    fontFamily:
      '"Inter", "Segoe UI", "Segoe UI Web (West European)", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif'
  },
  fonts: {
    medium: {
      fontSize: '13px'
    }
  },
  palette: {
    themePrimary: 'var(--primary-100)',
    themeLighterAlt: 'var(--primary-30-darker)',
    themeLighter: 'var(--primary-30)',
    themeLight: 'var(--primary-50)',
    themeTertiary: 'var(--primary-50-dark)',
    themeSecondary: 'var(--primary-50-darker)',
    themeDarkAlt: 'var(--primary-100-darker)',
    themeDark: 'var(--primary-100-dark)',
    themeDarker: 'var(--primary-100-darker)',
    neutralLighterAlt: 'var(--indigo-3)',
    neutralLighter: 'var(--indigo-2)',
    neutralLight: 'var(--indigo-4)',
    neutralQuaternaryAlt: 'var(--gray-3)',
    neutralQuaternary: 'var(--gray-4)',
    neutralTertiaryAlt: 'var(--indigo-6)',
    neutralTertiary: 'var(--indigo-7)',
    neutralSecondary: 'var(--indigo-8)',
    neutralPrimaryAlt: 'var(--gray-7)',
    neutralPrimary: 'var(--gray-8)',
    neutralDark: 'var(--gray-6)',
    black: 'var(--black-100)',
    white: 'var(--white-100)',
    redDark: 'var(--danger-100)'
  },
  effects: {
    roundedCorner2: '4px',
    roundedCorner4: '6px',
    roundedCorner6: '8px',
    elevation4: 'var(--depth-4)',
    elevation8: 'var(--depth-8)',
    elevation16: 'var(--depth-16)',
    elevation64: 'var(--depth-64)'
  },
  semanticColors: {
    disabledBackground: 'var(--gray-2)',

    errorText: 'var(--danger-100)',

    inputBorder: 'var(--indigo-4)',
    inputBorderHovered: 'var(--primary-100)',
    inputPlaceholderText: 'var(--gray-5)'
  }
})

export const useIcons = () => {
  initializeIcons()

  const { cdnCommonLib, cdnBasePath } = getConfig?.()?.publicRuntimeConfig

  registerIcons({
    fontFace: {
      fontFamily: '"FluentSystemIcons-Regular"',
      src: `url('${cdnBasePath}${cdnCommonLib}fluent-ui/f/FluentSystemIcons-Regular.woff') format('woff')`
    },
    icons: {
      add_24_filled: '\uf10a',
      alert_urgent_24_regular: '\uf11f',
      arrow_forward_24_regular: '\uf158',
      arrow_repeat_all_24_regular: '\uf172',
      arrow_reply_24_regular: '\uf178',
      arrow_sync_24_regular: '\uf191',
      arrow_up_circle_24_regular: '\uf1a0',
      calendar_date_24_regular: '\uf220',
      chevron_down_20_regular: '\uf2a3',
      chevron_up_24_regular: '\uf2b7',
      compose_20_regular: '\uf314',
      copy_24_regular: '\uf32c',
      delete_24_regular: '\uf34d',
      dismiss_24_regular: '\uf36a',
      dismiss_circle_24_regular: '\uf36e',
      document_edit_24_regular: '\uf387',
      location_not_found_24_regular: '\uf4fd',
      more_vertical_24_regular: '\uf557',
      office_apps_24_regular: '\uf57f',
      pause_24_regular: '\uf5a2',
      print_24_regular: '\uf62b',
      question_circle_20_regular: '\uf63d',
      tab_new_24_regular: '\uf759',
      mail_24_regular: '\uf507',
      slide_add_24_regular: '\uf6e6',
      more_vertical_20_regular: '\uf556',
      zoom_in_24_regular: '\uf8c5',
      zoom_out_24_regular: '\uf8c7'
    }
  })

  registerIcons({
    fontFace: {
      fontFamily: '"FluentSystemIcons-Filled"',
      src: `url('${cdnBasePath}${cdnCommonLib}fluent-ui/f/FluentSystemIcons-Filled.woff') format('woff')`
    },
    icons: {
      add_circle_24_filled: '\uf10d',
      arrow_right_24_filled: '\uf182',
      arrow_swap_24_filled: '\uf18e',
      arrow_undo_24_regular: '\uf19a',
      calendar_cancel_24_filled: '\uf21a',
      chevron_left_24_filled: '\uf2ab',
      chevron_right_24_filled: '\uf2b1',
      compose_24_filled: '\uf315',
      dismiss_24_filled: '\uf36a',
      document_edit_24_filled: '\uf387',
      edit_24_filled: '\uf3dd',
      info_24_filled: '\uf4ab',
      pause_24_filled: '\uf5ac',
      play_24_filled: '\uf610',
      print_24_filled: '\uf635',
      search_24_filled: '\uf69a',
      star_24_filled: '\uf719',
      tab_new_24_filled: '\uf771',
      warning_24_filled: '\uf882',
      block_24_filled: '\uf1dd',
      settings_24_filled: '\uf6b3',
      speaker_24_filled: '\uf706'
    }
  })

  registerIcons({
    fontFace: {
      fontFamily: '"icomoon"',
      src: `url('${cdnBasePath}${cdnCommonLib}fluent-ui/f/icomoon.woff') format('woff')`
    },
    icons: {
      Finances: '\ue900',
      Orders: '\ue901',
      Payouts: '\ue902',
      Products: '\ue903',
      SellPages: '\ue904',
      CrossEyes: '\ue905',
      FullStar: '\ue906',
      EmptyStar: '\ue907',
      Question: '\ue908'
    }
  })
}
